var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4016_68095)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75977,
    y: 5.15991,
    width: 3.36,
    height: 0.84,
    rx: 0.42,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50695 5.55381C8.50695 5.94162 8.43056 6.32564 8.28212 6.68392C8.13374 7.04222 7.91619 7.36776 7.64201 7.642C7.36776 7.91618 7.04222 8.13373 6.68392 8.28217C6.32564 8.43055 5.94163 8.50694 5.55382 8.50694C5.166 8.50694 4.78199 8.43055 4.4237 8.28217C4.06541 8.13373 3.73986 7.91618 3.46564 7.642C3.19141 7.36776 2.97389 7.04222 2.82548 6.68392C2.67707 6.32564 2.60069 5.94162 2.60069 5.55381C2.60069 4.77059 2.91182 4.01946 3.46564 3.46564C4.01946 2.91182 4.77059 2.60069 5.55382 2.60069C6.33703 2.60069 7.08817 2.91182 7.64201 3.46564C8.19582 4.01946 8.50695 4.77059 8.50695 5.55381ZM7.96882 8.66444C7.17763 9.27869 6.18209 9.56829 5.18487 9.47432C4.18765 9.38041 3.26373 8.90994 2.60118 8.15873C1.93863 7.40753 1.58728 6.43207 1.61863 5.43093C1.64999 4.42979 2.06171 3.47823 2.76997 2.76997C3.47823 2.06171 4.42979 1.64999 5.43093 1.61863C6.43207 1.58727 7.40753 1.93863 8.15874 2.60118C8.90995 3.26373 9.38042 4.18765 9.47433 5.18487C9.5683 6.18208 9.2787 7.17762 8.66445 7.96882L10.6594 9.96382C10.7078 10.0089 10.7466 10.0632 10.7735 10.1236C10.8004 10.184 10.8148 10.2492 10.816 10.3152C10.8172 10.3813 10.805 10.4469 10.7803 10.5082C10.7555 10.5695 10.7186 10.6252 10.6719 10.6719C10.6252 10.7187 10.5695 10.7555 10.5082 10.7803C10.447 10.805 10.3813 10.8172 10.3152 10.816C10.2492 10.8148 10.1839 10.8004 10.1236 10.7735C10.0632 10.7466 10.0089 10.7078 9.96382 10.6594L7.96882 8.66444Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4016_68095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2,
    height: 11.2,
    fill: "currentColor",
    transform: "translate(0.399902 0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom_out.7294e3192ea1d5e878263c6c052ae66a.svg";
export { ForwardRef as ReactComponent };